import React, {useEffect, useState } from 'react';
import { Row, Space,Button,Modal,Col } from 'antd';
import { FormProps } from '../../../utility/types';
import { useForm } from '../../../utility/useForm';
import { NoValidateForm, validateLoginForm } from '../../../utility/validationRules';
import { ValidationErrorSpan } from '../../../styles/global';
import { errorNotify, sucessNotify } from '../../../services/toast.notification';
import FormContainer from '../../../components/FormContainer/FormContainer';
import CustomTextArea from '../../../components/_common/CustomTextArea';
import CustomTable from '../../../components/_common/Table';
import { ColumnsType } from 'antd/lib/table';
import {  getRequestVmachine } from '../../../api/api';
import { useAppSelector } from '../../../redux/store/storehooks';
import Input from '../../../components/_common/Input';
import { ConfirmRequestMachin } from './confirm-request-machin';
import Tooltip from 'antd/es/tooltip';



export const RequestVmachineModal: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {
  const [showDialogConfirm,setshowDialogConfirm] = useState(false);
  const [sendConfirmMachin,setsendConfirmMachin] = useState({cableRequestId:0});
    const [desc, setDesc] = useState('');
    const [width, setWidth] = useState(1000);
    const handleChange = (event:any) => {
      setDesc(event.target.value);
    };


    const [lsvData,setData] = useState<any[]>([]);
  
    const [selectedLab,setSelectedLab] = useState("0");
    const [isLoading,setIsLoading] = useState(true);
    const columns: ColumnsType<any> = [
        {title: 'عملیات',dataIndex: 'Action',key: 'Action',render:(_,record) => (
          <Space>
               <Tooltip placement="right" title={setTooltip(record)
                // record.int_MachineInstallPrice
                }>
               <Button type="primary" 
           
           style={{backgroundColor:record.prk_MachineVLabInstallRequest_AutoID==0?'#54af548a':"green",
           color:record.prk_MachineVLabInstallRequest_AutoID==0?'#624e4e7a':'white'}} 
          
           disabled={record.prk_MachineVLabInstallRequest_AutoID==0?true:false}
           onClick={()=>
               SendItem(record)}> درخواست نصب</Button>
        </Tooltip>
       
          </Space>
       
        )},
        {title: 'نام دستگاه',dataIndex: 'str_MachineName',key: 'str_MachineName'},
        {title: 'شناسه آزمایشگاه',dataIndex: 'prk_MachineVLabInstallRequest_AutoID',key: 'prk_MachineVLabInstallRequest_AutoID'},
        {title: 'قیمت ',dataIndex: 'int_MachineInstallPrice',key: 'int_MachineInstallPrice'},
        {title: 'نوع نصب',dataIndex: 'int_InstallationType',key: 'int_InstallationType'},
    ];
    const setTooltip =(item:any)=>{
      if(item.prk_MachineVLabInstallRequest_AutoID==0)
       return item.int_MachineInstallPrice
       else
       return `درخواست با تایید مالی با ${item.int_MachineInstallPrice} ثبت میشود`
    }
    const myStore = useAppSelector((state) => state)
    const SendItem = (item:any) => {
      
      if(item.prk_MachineVLabInstallRequest_AutoID!=0){
        setshowDialogConfirm(true);
      
      
      setsendConfirmMachin((values:any) => ({
          
          ...values,
          prk_MachineVLabInstallRequest_AutoID:item.prk_MachineVLabInstallRequest_AutoID,
          mobile:payLoad.mobile,
           labId:payLoad.labId,
           int_MachineInstallPrice:item.int_MachineInstallPrice,
           frk_CenteralInstallerUserID :payLoad.frk_CenteralInstallerUserID 

          // deliveyType:values.prk_DeliveryType_AutoID
          // cableRequestId: id,
          // machineInstallRequestId:machineInstallRequestId,
          // labId:labId
        }));
        
      }
  }
    const RequestVmachine = () => {
        
        
     
        getRequestVmachine(payLoad.prk_installLabRequest_AutoID)
      .then((result:any) => {
        
        setData(result.data.data);
        setIsLoading(false);
       
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage,undefined,5000)
       
      })
    }
    
   
    useEffect(()=>{
      getWindowWith()
       
      RequestVmachine()
    },[])
    const getWindowWith=()=>{
      let w = window.innerWidth;
          setWidth(w-300)
    }
  
    return (
        <Modal
        
      
        width={width}
        bodyStyle={{ overflowX: 'auto' }}
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
            
        >
                  <input
                  style={{ marginTop: `15px`,direction:'rtl' }}
                  placeholder='توضیحات'
                      id="desc"
                       name="desc"
                        type="text"
                         onChange={handleChange}
                         value={desc}
      />

            <Row>
                <CustomTable columns={columns} data={lsvData} isloading={isLoading} 
                onAddClick={undefined} />
            </Row>
         
            {(() => {
        if (showDialogConfirm) {
           return   <ConfirmRequestMachin 
           payLoad={sendConfirmMachin}
           visible={showDialogConfirm}
           onSubmit={() => console.log(true)}
           onCancel={() => {setshowDialogConfirm(false);RequestVmachine()}}
           setShowDialog ={() => {setshowDialogConfirm(false)}}
       /> 
        } 
      })()}
        </Modal>
    )
}